import React from "react";
import { ShieldCheck, MapPin, Mail } from "lucide-react";
import { nzTaxLink } from "@/lib/conversion";

export default function SiteFooter({ onDark = true }) {
  return (
    <footer
      className={`mt-16 border-t border-[var(--border)] ${
        onDark ? "bg-[var(--surface)]" : ""
      }`}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="font-display text-lg leading-none">
            NZ TAXATION <span className="text-[var(--primary)]">LTD</span>
          </div>
          <div className="label-mono mt-1">TRADIE CALCULATOR</div>
          <p className="text-zinc-400 text-sm mt-4 max-w-md leading-relaxed">
            Free calculators for NZ tradies — built by{" "}
            <a
              href={nzTaxLink("/", "footer-brand")}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--primary)] underline"
            >
              NZ Taxation Ltd
            </a>
            , a fully remote IRD-registered tax practice. We help sole traders
            and small companies stop guessing about tax.
          </p>
          <div className="flex flex-wrap gap-4 mt-5 text-xs font-mono text-zinc-400">
            <span className="flex items-center gap-2">
              <ShieldCheck size={12} className="text-[var(--primary)]" /> IRD-registered
              tax agents
            </span>
            <span className="flex items-center gap-2">
              <MapPin size={12} className="text-[var(--primary)]" /> Te Atatū, Auckland
            </span>
          </div>
        </div>

        <div>
          <div className="label-mono">Main site</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <a
                href={nzTaxLink("/", "footer-home")}
                target="_blank"
                rel="noopener noreferrer"
                className="text-zinc-300 hover:text-[var(--primary)]"
                data-testid="footer-link-home"
              >
                nztaxation.nz
              </a>
            </li>
            <li>
              <a
                href={nzTaxLink("/#pricing", "footer-pricing")}
                target="_blank"
                rel="noopener noreferrer"
                className="text-zinc-300 hover:text-[var(--primary)]"
                data-testid="footer-link-pricing"
              >
                Pricing
              </a>
            </li>
            <li>
              <a
                href={nzTaxLink("/#how", "footer-how")}
                target="_blank"
                rel="noopener noreferrer"
                className="text-zinc-300 hover:text-[var(--primary)]"
                data-testid="footer-link-how"
              >
                How it works
              </a>
            </li>
            <li>
              <a
                href={nzTaxLink("/#faq", "footer-faq")}
                target="_blank"
                rel="noopener noreferrer"
                className="text-zinc-300 hover:text-[var(--primary)]"
                data-testid="footer-link-faq"
              >
                FAQ
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="label-mono">Get in touch</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <a
                href="mailto:info@nztaxation.nz"
                className="flex items-center gap-2 text-zinc-300 hover:text-[var(--primary)]"
                data-testid="footer-link-email"
              >
                <Mail size={12} /> info@nztaxation.nz
              </a>
            </li>
          </ul>
          <a
            href={nzTaxLink("/#pricing", "footer-cta")}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-xs mt-5 inline-flex"
            data-testid="footer-cta-pricing"
          >
            Hire us
          </a>
        </div>
      </div>
      <div className="border-t border-[var(--border)]">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-wrap gap-2 justify-between text-[11px] font-mono text-zinc-500">
          <span>© {new Date().getFullYear()} NZ Taxation Ltd · Made in Aotearoa</span>
          <span>
            These calculators are estimates only — confirm with IRD or your
            accountant.
          </span>
        </div>
      </div>
    </footer>
  );
}
